import { render, staticRenderFns } from "./AddMechanizationsModal.vue?vue&type=template&id=13d939fa&scoped=true"
import script from "./AddMechanizationsModal.vue?vue&type=script&lang=js"
export * from "./AddMechanizationsModal.vue?vue&type=script&lang=js"
import style0 from "./AddMechanizationsModal.vue?vue&type=style&index=0&id=13d939fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d939fa",
  null
  
)

export default component.exports